import { useInfiniteQuery } from "@tanstack/react-query";
import { getHomeHistory } from "../../api/hub/home";
import { DataState, HomePanel } from "./Frame";
import { dateLabel, homeKeys, message, useWorkspaceMe } from "./data";
export function HomeHistoryPanel(
  { currentVersion, busy, onRevert, onClose }: {
    currentVersion: number;
    busy: boolean;
    onRevert: (version: number) => void;
    onClose: () => void;
  },
) {
  const me = useWorkspaceMe(),
    query = useInfiniteQuery({
      queryKey: homeKeys.history(),
      initialPageParam: undefined as number | undefined,
      queryFn: ({ pageParam }) => getHomeHistory(pageParam),
      getNextPageParam: (page) =>
        page.hasMore && page.nextCursor !== null ? page.nextCursor : undefined,
    });
  const items = query.data?.pages.flatMap((page) => page.items) ?? [];
  return (
    <HomePanel title="版本历史" onClose={onClose}>
      <p className="home-muted">
        保存、AI
        改动、撤销和恢复都保留记录。恢复一个历史版本会生成新的当前版本。
      </p>
      <DataState
        query={query}
        isEmpty={!items.length}
        empty="还没有个人修改，当前跟随默认布局。"
      >
        <ol className="home-timeline">
          {items.map((item) => (
            <li key={item.version}>
              <strong>
                v{item.version} · {item.author.kind === "ai"
                  ? "AI · " +
                    (item.author.keyName || item.author.keyId || "个人 Key")
                  : "本人网页"}{" "}
                {item.version === currentVersion && (
                  <span className="home-tag">当前</span>
                )}
              </strong>
              <p className="home-muted">
                {dateLabel(item.createdAt, me.data?.data.timezone)} ·{" "}
                {item.source === "personal" ? "个人布局" : "跟随角色默认"}
              </p>
              <ul>
                {item.changeSummary.map((change, i) => <li key={i}>{change}
                </li>)}
              </ul>
              {item.version !== currentVersion && (
                <button
                  disabled={busy}
                  onClick={() => onRevert(item.version)}
                >
                  恢复 v{item.version}
                </button>
              )}
            </li>
          ))}
        </ol>
      </DataState>
      {query.isFetchNextPageError && (
        <p role="alert" className="home-error">{message(query.error)}</p>
      )}
      {query.hasNextPage && (
        <button
          disabled={query.isFetchingNextPage}
          onClick={() => void query.fetchNextPage()}
        >
          {query.isFetchingNextPage ? "读取中…" : "更早的版本"}
        </button>
      )}
    </HomePanel>
  );
}
